import { Routes } from '@angular/router';
import { PromotionalType01Component } from './promotional-type01/promotional-type01.component';
export default [
    {
        path     : '',
        component: PromotionalType01Component,
    },
    
] as Routes;
